/* Public product context for personal advice. Booking stays with the native app. */
(function (scope, factory) {
  'use strict';
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (!scope || !scope.document || scope.__pgAdviceContext) return;
  scope.__pgAdviceContext = true;
  function start() { api.mount(scope); }
  if (scope.document.readyState === 'loading') scope.document.addEventListener('DOMContentLoaded', start);
  else start();
  scope.document.addEventListener('shopify:section:load', start);
}(typeof window !== 'undefined' ? window : null, function () {
  'use strict';
  function validHandle(value) {
    return typeof value === 'string' && value.length > 0 && value.length <= 255 &&
      /^[\p{L}\p{M}\p{N}_™®-]+$/u.test(value) && encodeURIComponent(value).length <= 2048;
  }
  function validVariant(value) { return typeof value === 'string' && /^[1-9]\d{0,19}$/.test(value); }
  function readSelection(search) {
    var params = new URLSearchParams(search);
    if (!params.has('product')) return null;
    var handle = params.get('product');
    var variant = params.get('variant');
    if (params.getAll('product').length !== 1 || params.getAll('variant').length > 1 ||
        !validHandle(handle) || (variant !== null && !validVariant(variant))) return { invalid: true };
    return { handle: handle, variant: variant };
  }
  function productPath(root, handle) {
    var safeRoot = typeof root === 'string' && /^\/(?:[a-z]{2}(?:-[a-z0-9]{2,8})?\/?)?$/i.test(root) ? root : '/';
    return safeRoot.replace(/\/?$/, '/') + 'products/' + encodeURIComponent(handle);
  }
  function resolveProduct(selection, product, root) {
    if (!selection || selection.invalid || !product || product.handle !== selection.handle ||
        typeof product.title !== 'string' || !product.title.trim()) throw new Error('Invalid product');
    var variant = null;
    if (selection.variant !== null) {
      variant = Array.isArray(product.variants) && product.variants.find(function (item) { return String(item.id) === selection.variant; });
      if (!variant) throw new Error('Variant no longer exists');
    }
    return {
      title: product.title,
      variant: variant && variant.title !== 'Default Title' ? String(variant.title || '') : '',
      sku: variant ? String(variant.sku || '') : '',
      image: variant && variant.featured_image ? variant.featured_image.src : product.featured_image,
      url: productPath(root, selection.handle) + (variant ? '?variant=' + selection.variant : '')
    };
  }
  function safeImage(value, origin) {
    if (typeof value !== 'string' || !value) return '';
    try {
      var url = new URL(value, origin);
      if (url.protocol !== 'https:' || url.username || url.password) return '';
      return url.origin === origin || url.hostname === 'cdn.shopify.com' ? url.href : '';
    } catch (_) { return ''; }
  }
  function updateAdviceLink(href, handle, variant, origin) {
    if (!validHandle(handle)) return null;
    try {
      var url = new URL(href, origin);
      if (url.origin !== origin || !/\/pages\/termin$/.test(url.pathname)) return null;
      url.searchParams.set('product', handle);
      if (validVariant(variant)) url.searchParams.set('variant', variant);
      else url.searchParams.delete('variant');
      return url.pathname + url.search + url.hash;
    } catch (_) { return null; }
  }
  function clearSelection(href) {
    var url = new URL(href);
    url.searchParams.delete('product');
    url.searchParams.delete('variant');
    return url.pathname + url.search + url.hash;
  }
  function mount(win) {
    var doc = win.document;
    doc.querySelectorAll('[data-pg-advice-link]').forEach(function (link) {
      if (link.dataset.pgAdviceReady) return;
      link.dataset.pgAdviceReady = 'true';
      function sync(id) {
        var href = updateAdviceLink(link.getAttribute('href'), link.dataset.pgAdviceProduct, id, win.location.origin);
        if (href) link.setAttribute('href', href);
      }
      function fromForm() {
        var input = doc.querySelector('#pg-pdp-form [data-pg-variant-id]');
        if (input) sync(input.value);
      }
      doc.addEventListener('pg:variant-changed', function (event) { sync(event.detail && event.detail.id); });
      link.addEventListener('click', fromForm);
      fromForm();
    });
    doc.querySelectorAll('[data-pg-advice-context]').forEach(function (root) {
      if (root.dataset.pgAdviceReady) return;
      root.dataset.pgAdviceReady = 'true';
      var selection = readSelection(win.location.search);
      if (!selection) return;
      var status = root.querySelector('[data-pg-advice-status]');
      var body = root.querySelector('[data-pg-advice-body]');
      var retry = root.querySelector('[data-pg-advice-retry]');
      var summary = root.querySelector('[data-pg-advice-summary]');
      var copy = root.querySelector('[data-pg-advice-copy]');
      var copyStatus = root.querySelector('[data-pg-advice-copy-status]');
      var controller = null;
      var generation = 0;
      root.hidden = false;
      function clear() {
        generation += 1;
        if (controller) controller.abort();
        root.hidden = true;
        try { win.history.replaceState(win.history.state, '', clearSelection(win.location.href)); } catch (_) { /* The booking is still usable. */ }
      }
      root.querySelector('[data-pg-advice-clear]').addEventListener('click', function () {
        clear();
        var heading = doc.querySelector('[data-pg-booking-current="true"] [data-pg-booking-heading], .pg-termin__title');
        if (heading) { heading.setAttribute('tabindex', '-1'); heading.focus({ preventScroll: true }); }
      });
      async function load(fromRetry) {
        var ownGeneration = ++generation;
        if (controller) controller.abort();
        body.hidden = true;
        retry.hidden = true;
        status.hidden = false;
        status.textContent = root.dataset.loading;
        if (fromRetry) { status.setAttribute('tabindex', '-1'); status.focus({ preventScroll: true }); }
        if (selection.invalid) { status.textContent = root.dataset.invalid; return; }
        controller = new win.AbortController();
        var requestController = controller;
        var timeout = win.setTimeout(function () { requestController.abort(); }, 10000);
        try {
          var response = await win.fetch(productPath(root.dataset.root, selection.handle) + '.js', {
            signal: controller.signal, credentials: 'same-origin', headers: { Accept: 'application/json' }
          });
          if (!response.ok) throw new Error('Product unavailable');
          var product = resolveProduct(selection, await response.json(), root.dataset.root);
          if (ownGeneration !== generation) return;
          root.querySelector('[data-pg-advice-title]').textContent = product.title;
          var variant = root.querySelector('[data-pg-advice-variant]');
          variant.textContent = [product.variant, product.sku ? 'SKU: ' + product.sku : ''].filter(Boolean).join(' · ');
          variant.hidden = !variant.textContent;
          root.querySelector('[data-pg-advice-product]').setAttribute('href', product.url);
          var image = root.querySelector('[data-pg-advice-image]');
          var source = safeImage(product.image, win.location.origin);
          image.hidden = !source;
          if (source) {
            image.onerror = function () { image.hidden = true; };
            image.src = source;
          }
          summary.value = [product.title, product.variant, product.sku ? 'SKU: ' + product.sku : '', win.location.origin + product.url].filter(Boolean).join('\n');
          body.hidden = false;
          if (fromRetry && doc.activeElement === status) root.querySelector('[data-pg-advice-product]').focus({ preventScroll: true });
          status.textContent = '';
          status.hidden = true;
        } catch (_) {
          if (ownGeneration !== generation) return;
          status.textContent = root.dataset.error;
          retry.hidden = false;
          if (fromRetry && doc.activeElement === status) retry.focus({ preventScroll: true });
        } finally { win.clearTimeout(timeout); }
      }
      retry.addEventListener('click', function () { return load(true); });
      copy.addEventListener('click', async function () {
        copy.disabled = true;
        try {
          if (!win.navigator.clipboard) throw new Error('Clipboard unavailable');
          await win.navigator.clipboard.writeText(summary.value);
          copyStatus.textContent = root.dataset.copied;
        } catch (_) {
          summary.closest('details').open = true;
          summary.focus();
          summary.select();
          copyStatus.textContent = root.dataset.copyFallback;
        } finally { copy.disabled = false; }
      });
      load();
    });
  }
  return { validHandle: validHandle, validVariant: validVariant, readSelection: readSelection, productPath: productPath,
    resolveProduct: resolveProduct, safeImage: safeImage, updateAdviceLink: updateAdviceLink, clearSelection: clearSelection, mount: mount };
}));
